import { Box, MenuItem, Select, SelectProps } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { CreateForm } from ".";

type Params = {
  value: CreateForm["repeatEvery"];
  onChange: (value: CreateForm["repeatEvery"]) => void;
};
export default function SelectRepeat({ value, onChange: emitChange }: Params) {
  const { t } = useTranslation("datasets");
  const selectDisplayProps = {
    "data-testid": "dataset-form-sync-repeat",
  } as React.HTMLAttributes<HTMLDivElement>;

  const onChangeHandler: SelectProps["onChange"] = e => {
    const { value } = e.target;
    const newValue = parseInt(value as string, 10) as CreateForm["repeatEvery"];
    emitChange(newValue);
  };

  return (
    <Box display="flex" alignItems="center" mt={2}>
      <Box mr={2}>{t("syncForm.repeatLabel")}</Box>

      <Select
        variant="outlined"
        value={(value ?? 0).toString()}
        SelectDisplayProps={selectDisplayProps}
        onChange={onChangeHandler}
      >
        <MenuItem value="0" data-testid="dataset-form-sync-repeat-option-0">
          {t("syncForm.noRepeat")}
        </MenuItem>
        <MenuItem value="6" data-testid="dataset-form-sync-repeat-option-6">
          {t("syncForm.every6h")}
        </MenuItem>
        <MenuItem value="12" data-testid="dataset-form-sync-repeat-option-12">
          {t("syncForm.every12h")}
        </MenuItem>
        <MenuItem value="24" data-testid="dataset-form-sync-repeat-option-24">
          {t("syncForm.every24h")}
        </MenuItem>
      </Select>
    </Box>
  );
}
